<!-- Start Page Title Area -->
<section class="blog-details-section">
    <div class="page-title-area">
        <div class="container">
            <div class="page-title-content">
                <h2 style="padding-top: 10px; white-space: pre-wrap">
                    {{ info }}
                </h2>
                <h2 style="padding-top: 10px">{{ infoDetail }}</h2>
            </div>
        </div>
    </div>
    <!-- End Page Title Area -->

    <ng-template ngFor [ngForOf]="blockList" let-block>
        <!-- 標題 + 副標題 + 一張圖(可以有超連結) -->
        <section
            class="features-area mt-110"
            *ngIf="block.blockType == 1"
            [style.background]="'url(' + block.backImg + ')'"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{
                'ptb-100': block.backImg != null,
                'mt-0': block.backImg != null
            }"
        >
            <div class="container blockContainer">
                <div class="section-title">
                    <h2
                        [innerHTML]="block.title"
                        *ngIf="block.title != null || block.title != 'N/A'"
                    ></h2>
                    <p
                        [innerHTML]="block.subtitle"
                        *ngIf="
                            block.subtitle != null || block.subtitle != 'N/A'
                        "
                    ></p>
                </div>
                <div
                    class="mb-5"
                    style="text-align: center"
                    *ngIf="block.blockImg != null"
                >
                    <a
                        [href]="block.imgLink"
                        style="display: inline"
                        *ngIf="block.imgLink != null"
                    >
                        <img class="ad" [src]="block.blockImg" />
                    </a>
                    <img
                        class="pic4"
                        [src]="block.blockImg"
                        *ngIf="block.imgLink == null"
                    />
                </div>
            </div>
        </section>

        <!-- 標題 + 副標題 + 多圖(可以有超連結) -->
        <section
            class="features-area mt-110"
            [style.background]="'url(' + block.backImg + ')'"
            *ngIf="block.blockType == 2"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{
                'ptb-100': block.backImg != null,
                'mt-0': block.backImg != null
            }"
        >
            <div class="container">
                <div class="section-title">
                    <h2 [innerHTML]="block.title"></h2>
                    <p [innerHTML]="block.subtitle"></p>
                </div>

                <div
                    class="row"
                    style="justify-content: space-between; text-align: center"
                >
                    <div
                        class="col-lg-6 col-md-4 col-sm-6 mb-5"
                        *ngFor="let img of block.multipleImg"
                    >
                        <a href="{{ img.imgLink }}" *ngIf="img.imgLink != null"
                            ><img class="iconpic" src="{{ img.img }}"
                        /></a>
                        <img
                            *ngIf="img.imgLink == null"
                            class="iconpic"
                            src="{{ img.img }}"
                        />
                    </div>
                </div>
            </div>
        </section>

        <!-- 標題(可有可無) + 副標題 -->
        <section
            class="features-area"
            [style.background]="'url(' + block.backImg + ')'"
            *ngIf="block.blockType == 3"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{ 'mt-0': block.backImg != null }"
        >
            <div class="container blockContainer">
                <div
                    class="section-title"
                    style="margin-bottom: 0px; margin-top: 0px"
                >
                    <h3
                        *ngIf="block.title != null"
                        style="
                            padding-top: 30px;
                            color: #2681bd;
                            text-align: left;
                        "
                        [innerHTML]="block.title"
                    ></h3>
                    <p
                        style="padding-bottom: 30px"
                        [innerHTML]="block.subtitle"
                    ></p>
                </div>
            </div>
        </section>

        <!-- 標題(可有可無) + 多圖(可以有超連結) -->
        <section
            class="features-area mt-60"
            [style.background]="'url(' + block.backImg + ')'"
            *ngIf="block.blockType == 4"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{
                'ptb-100': block.backImg != null,
                'mt-0': block.backImg != null
            }"
        >
            <div
                class="container px-0 max-w-[60%] md:max-w-[60%] max-md:max-w-[80%]"
            >
                <h3
                    *ngIf="block.title != null"
                    style="color: #ffa200; text-align: left; margin-left: 10px"
                    [innerHTML]="block.title"
                ></h3>
                <div
                    class="row"
                    style="
                        margin-left: 0px;
                        margin-right: 0px;
                        justify-content: space-around;
                    "
                >
                    <div
                        class="col-lg-6 col-md-12 col-sm-12 mb-5"
                        *ngFor="let img of block.multipleImg"
                        style="text-align: center"
                    >
                        <ng-container *ngIf="img.imgLink != null"
                            ><a href="{{ img.imgLink }}"
                                ><img src="{{ img.img }}"
                            /></a>
                        </ng-container>
                        <ng-container *ngIf="img.imgLink == null"
                            ><img src="{{ img.img }}" />
                            <p style="text-align: left; font-size: 17px">
                                {{ img.info }}
                            </p></ng-container
                        >
                    </div>
                </div>
            </div>
        </section>

        <!-- 圖片 + 圖片標題 -->
        <section
            class="features-area mt-60"
            [style.background]="'url(' + block.backImg + ')'"
            *ngIf="block.blockType == 5"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{
                'ptb-100': block.backImg != null,
                'mt-0': block.backImg != null
            }"
        >
            <div
                class="container"
                style="max-width: 100%; padding-right: 0px; padding-left: 0px"
            >
                <div class="mb-5" style="text-align: center">
                    <img class="pic19" src="{{ block.blockImg }}" />
                    <p
                        *ngIf="block.subtitle != null"
                        class="type5subtitle"
                        [innerHTML]="block.subtitle"
                    ></p>
                </div>
            </div>
            <!-- <div class="services-shape "><img src="assets/img/services-shape.png " alt="image "></div> -->
        </section>

        <!-- 圖片左右 + 文字 -->
        <section
            class="features-area mt-60 mb-5"
            [style.background]="'url(' + block.backImg + ')'"
            *ngIf="block.blockType == 6"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{
                'ptb-100': block.backImg != null,
                'mt-0': block.backImg != null
            }"
        >
            <div
                class="container max-w-[65%] md:max-w-[65%] max-md:max-w-[80%]"
            >
                <div class="overview-box" style="justify-content: space-evenly">
                    <div
                        class="about-pic-div"
                        *ngIf="block.imgPosition == 'left'"
                        style="text-align: start"
                    >
                        <img
                            class="about-pic"
                            [src]="block.blockImg"
                            alt="image"
                            *ngIf="block.blockImg != null"
                        />
                        <div [innerHTML]="block.imgInfo"></div>
                    </div>
                    <div class="content">
                        <h3 [innerHTML]="block.title"></h3>
                        <p [innerHTML]="block.content"></p>
                    </div>
                    <div
                        class="about-pic-div"
                        *ngIf="block.imgPosition == 'right'"
                        style="text-align: end"
                    >
                        <img
                            class="about-pic"
                            [src]="block.blockImg"
                            alt="image"
                            *ngIf="block.blockImg != null"
                        />
                        <div [innerHTML]="block.imgInfo"></div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 有超連結的多圖(沒有標題) -->
        <section
            class="services-area mt-110"
            [style.background]="'url(' + block.backImg + ')'"
            *ngIf="block.blockType == 7"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{
                'ptb-100': block.backImg != null,
                'mt-0': block.backImg != null
            }"
        >
            <div class="container solutions-container">
                <div class="row">
                    <div
                        class="col-6 col-lg-3 col-md-6 col-sm-6"
                        *ngFor="let img of block.multipleImg"
                    >
                        <ng-container *ngIf="img.imgLink != null">
                            <a [href]="img.imgLink">
                                <div class="single-services-box">
                                    <div class="icon">
                                        <img [src]="img.img" alt="image" />
                                    </div>
                                    <h3>{{ img.imgTitle }}</h3>
                                </div>
                            </a>
                        </ng-container>
                        <ng-container *ngIf="img.imgLink == null">
                            <div class="single-services-box">
                                <div class="icon">
                                    <img [src]="img.img" alt="image" />
                                </div>
                                <h3>{{ img.imgTitle }}</h3>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </section>

        <!-- 一張圖(可以有超連結) -->
        <section
            class="features-area"
            [style.background]="'url(' + block.backImg + ')'"
            *ngIf="block.blockType == 8"
            [ngStyle]="{
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%'
            }"
            [ngClass]="{
                'ptb-100': block.backImg != null,
                'mt-0': block.backImg != null,
                'mt-60': block.blockIndex == 0,
                'mb-5': block.blockIndex == -1
            }"
        >
            <div
                class="container"
                style="max-width: 100%; padding-right: 0px; padding-left: 0px"
            >
                <div style="text-align: center">
                    <a
                        href="{{ block.imgLink }}"
                        target="_blank"
                        *ngIf="block.imgLink != null"
                        ><img class="pic19" src="{{ block.blockImg }}"
                    /></a>
                    <img
                        class="pic19"
                        *ngIf="block.imgLink == null"
                        src="{{ block.blockImg }}"
                    />
                </div>
            </div>
        </section>
    </ng-template>
</section>
<!-- End Blog Details Area -->
